// client/extensions/History.ts
import TiptapHistory from "@tiptap/extension-history";
var HistoryTranslations = {
  history: {
    undo: ["R\xFCckg\xE4ngig", "Undo"],
    redo: ["Wiederholen", "Redo"]
  }
};
var History = {
  buttons: ({ editor, host }) => {
    const buttons = [];
    if (editor.can().redo())
      buttons.unshift({
        name: "redo",
        icon: "redo",
        action: () => editor.commands.redo(),
        tooltip: host.translator.translate("tiptap", "history", "redo")
      });
    if (editor.can().undo())
      buttons.unshift({
        name: "undo",
        icon: "undo",
        action: () => editor.commands.undo(),
        tooltip: host.translator.translate("tiptap", "history", "undo")
      });
    return buttons;
  },
  extensions: [TiptapHistory]
};
export {
  History,
  HistoryTranslations
};
